export enum GLOBAL_KEYS {
    LANG = 'lang'
}

export enum COOKIE_KEYS {
    AUTH_TOKEN = 'txToken'
}

export enum AGORA_RTC_LOG_LEVEL {
    DEBUG,
    INFO,
    WARNING,
    ERROR,
    NONE
}

export enum AGORA_RTC_ERROR {
    NOT_SUPPORTED = 'NOT_SUPPORTED',
    PERMISSION_DENIED = 'PERMISSION_DENIED',
    NOT_READABLE = 'NOT_READABLE',
    AUDIO_NOT_SUPPORTED = 'AUDIO_NOT_SUPPORTED',
    VIDEO_NOT_SUPPORTED = 'VIDEO_NOT_SUPPORTED'
}

export enum BAIDU_AI_INTERFACE_ERROR {
    BAIDU_AI_TTS_ERROR = 'BAIDU_AI_TTS_ERROR'
}

export enum TTS_PLAY_STATUS {
    STOPED = 'stopped',
    PLAYING = 'playing',
    PAUSED = 'paused'
}

export enum SPEECH_RECOGNITION_STEPS {
    PLAY_VOICE,
    ANSWER,
    RESULT,
    UNDEFINED
}

export enum VERIFICATION_TYPE {
    VERIFY_IMAGE = 'verify_image',
    VERIFY_IDCARD = 'verify_idcard',
    TTS_ASR = 'tts_asr',
    TTS_ASR_STD = 'tts_asr_std',
    TTS_ASR_SPEAKER = 'tts_asr_speaker',
    UNDEFINED = 'undefined',
    CONTRACT = 'contract',
    SIGNATURE = 'signature'
}

export enum IMAGE_TYPE {
    URL = 'URL',
    BASE64 = 'BASE64'
}

export enum VERIFY_STATE {
    PASS = 10,
    NO_PASS = 20
}

export enum VERIFY_FACE_TYPE {
    LIVE_VERIFY = 'liveVerify',
    FACE_MATCH = 'faceMatch'
}

export enum RECORD_CUSTOM_EVENT {
    VIDEO_PLAY_EVENT = 'video_play_event',
    VIDEO_PAUSE_EVENT = 'video_pause_event',
    START_RECORD_AUDIO = 'start_record_audio',
    STOP_RECORD_AUDIO = 'stop_record_audio',
    RECORD_AUDIO_VOLUME_CHANGE = 'record_audio_volume_change',
    AUDIO_PLAY_EVENT = 'audio_play_event',
    AUDIO_PAUSE_EVENT = 'audio_pause_event',
    START_RECORD_STREAM = 'start_record_stream',
    VERIFY_SUCCESS = 'verify_success',
    VERIFY_FAILED = 'verify_failed'
}

export enum VERIFY_FAILED {
    FAILED_201 = 201,
    FAILED_202 = 202,
    FAILED_203 = 203,
    FAILED_204 = 204,
    FAILED_205 = 205,
    FAILED_206 = 206,
    FAILED_307 = 307
}

export enum HTTP_ERROR {
    LOGIC_ERROR,
    TIMEOUT_ERROR,
    NETWORK_ERROR
}

export enum ERROR_CODE {
    ERROR_UNKNOWN = -10000,
    ERROR_110 = 110,
    ERROR_201 = 201,
    ERROR_202 = 202,
    ERROR_301 = 301,
    ERROR_302 = 302,
    ERROR_11001 = 11001,
    ERROR_11002 = 11002,
    ERROR_11003 = 11003,
    ERROR_11004 = 11004,
    ERROR_11005 = 11005,
    ERROR_12001 = 12001,
    ERROR_12002 = 12002,
    ERROR_12003 = 12003,
    ERROR_12004 = 12004,
    ERROR_13001 = 13001,
    ERROR_13002 = 13002,
    ERROR_13003 = 13003,
    ERROR_14001 = 14001,
    ERROR_21001 = 21001,
    ERROR_21002 = 21002,
    ERROR_22001 = 22001,
    ERROR_22002 = 22002,
    ERROR_22003 = 22003,
    ERROR_22004 = 22004,
    ERROR_22005 = 22005,
    ERROR_23011 = 23011,
    ERROR_23012 = 23012,
    ERROR_23021 = 23021,
    ERROR_23031 = 23031,
    ERROR_24031 = 24031,
    ERROR_24032 = 24032,
    ERROR_24033 = 24033,
    ERROR_24041 = 24041,
    ERROR_31001 = 31001,
    ERROR_31101 = 31101,
    ERROR_31102 = 31102,
    ERROR_31201 = 31201,
    ERROR_31202 = 31202,
    ERROR_31301 = 31301,
    ERROR_31302 = 31302,
    ERROR_31303 = 31303,
    ERROR_13004 = 13004
}

export const tenantIds: Array<string> = ['616808e9d0c23a25b02a8449', '6437a1c17058ae169cb2bfe2'];
